(function () {
    'use strict';

    angular
        .module('garanteasyApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('warranty-claim-file', {
                parent: 'entity',
                url: '/warranty-claim-file',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.warrantyClaimFile.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-files.html',
                        controller: 'WarrantyClaimFileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warrantyClaimFile');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('warranty-claim-file-detail', {
                parent: 'entity',
                url: '/warranty-claim-file/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'garanteasyApp.warrantyClaimFile.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-file-detail-html',
                        controller: 'WarrantyClaimFileDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warrantyClaimFile');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'WarrantyClaimFile', function ($stateParams, WarrantyClaimFile) {
                        return WarrantyClaimFile.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'warranty-claim-file',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('warranty-claim-file-detail-edit', {
                parent: 'warranty-claim-file-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-file-dialog.html',
                        controller: 'WarrantyClaimFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['WarrantyClaimFile', function (WarrantyClaimFile) {
                                return WarrantyClaimFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('warranty-claim-file-new', {
                parent: 'warranty-claim-file',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-file-dialog.html',
                        controller: 'WarrantyClaimFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    fileName: null,
                                    fileContentType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('warranty-claim-file', null, { reload: true });
                    }, function () {
                        $state.go('warranty-claim-file');
                    });
                }]
            })
            .state('warranty-claim-file-edit', {
                parent: 'warranty-claim-file',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-file-dialog.html',
                        controller: 'WarrantyClaimFileDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['WarrantyClaimFile', function (WarrantyClaimFile) {
                                return WarrantyClaimFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('warranty-claim-file', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('warranty-claim-file-delete', {
                parent: 'warranty-claim-file',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/warranty-claim-file/warranty-claim-file-delete-dialog.html',
                        controller: 'WarrantyClaimFileDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['WarrantyClaimFile', function (WarrantyClaimFile) {
                                return WarrantyClaimFile.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('warranty-claim-file', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
